(function () {
  'use strict';

  angular
    .module('app.student', []);
  
})();